module.exports = ".truncate-cell {\n    max-width: 250px; /* feel free to include any other value */\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/content-management/content-management.component.css
// module id = ./src/app/content-management/content-management.component.css
// module chunks = main